import * as React from "react";
import { forwardRef } from "react";
const SvgCrossIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.5 3.5L3.5 12.5", stroke: "#999999", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.5 12.5L3.5 3.5", stroke: "#999999", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCrossIcon);
export { ForwardRef as ReactComponent };
